import { Charts } from './Charts';
import CadUniqueChartsDataProvider from './contexts/CadUniqueChartsDataContext';

const CadUniqueWrapper = () => {
    return (
        <CadUniqueChartsDataProvider>
            <Charts />
        </CadUniqueChartsDataProvider>
    );
};

export default CadUniqueWrapper;
